import {numberFormat} from "../common";
export function updateCartInfo(cartInfo) {
    document.querySelectorAll('.rbm_js_count_cart_full').forEach(item => item.innerHTML = cartInfo.count_2 || 0);
    document.querySelectorAll('.rbm_js_count_cart').forEach(item => item.innerHTML = cartInfo.count_1 || 0);

    let d_price = parseInt(cartInfo.price || 0);
    let n_price = parseInt(cartInfo.not_discount_price || 0)
    document.querySelectorAll('.js_total_price').forEach(item => item.innerHTML = numberFormat(d_price, 0, ' ', ' '));
    document.querySelectorAll('.js_old_total_price').forEach(item => item.innerHTML = numberFormat(n_price, 0, ' ', ' '));
}